/**
 * 会话失效判定（用户端 / 管理端共用）。
 * - 业务码 `401`：{@code ErrorCode.UNAUTHORIZED}
 * - HTTP 401 且无业务码或业务码非 AUTH_FAILED（登录失败）
 */
export function isApiSessionExpired(
  code: string | undefined,
  httpStatus?: number,
): boolean {
  if (code === "401") return true;
  if (httpStatus === 401 && code !== "AUTH_FAILED") return true;
  return false;
}
